import { render } from "./create_inpatient_service_modal.vue?vue&type=template&id=2190f81c&scoped=true"
import script from "./create_inpatient_service_modal.vue?vue&type=script&lang=js"
export * from "./create_inpatient_service_modal.vue?vue&type=script&lang=js"

import "./create_inpatient_service_modal.vue?vue&type=style&index=0&id=2190f81c&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2190f81c"]])

export default __exports__